module.exports = __webpack_public_path__ + "static/img/recruiter-magazine.5290160.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/recruiter-magazine.jpg
// module id = m13Z
// module chunks = 0